import React from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import Scrollbar from "react-perfect-scrollbar-z";
import config from "@_configs/api.config";
import CasesRow from "@_components/CaseRow/CaseRow";
import "scrollbar.css";
import styles from "../Cases.module.css";

function CaseList({
  cases,
  casesGetStatus,
  selections,
  sidebarStatus,
  onNext,
  hasMore,
  onScrollLoad,
}) {
  return (
    <div id="scrollableDiv" className={styles.case_scroll_container}>
      <InfiniteScroll
        dataLength={cases.length}
        next={onNext}
        hasMore={hasMore}
        loader={
          <>
            {casesGetStatus === "request" && (
              <div className="loader" key={0}>
                Loading ...
              </div>
            )}
          </>
        }
        scrollableTarget="scrollableDiv"
        endMessage={<p>No more data to load.</p>}
      >
        <Scrollbar
          effectData={cases.length}
          id="sb"
          maxHeight="calc(100vh - 288px)"
          onScrollY={(ev) => {
            if (ev.target?.scrollTop / ev.target.scrollHeight > 0.94) {
              if (
                ev.target.children &&
                (ev.target.children.length % config.PAGE_SIZE) - 2 === 0
              )
                onScrollLoad();
            }
          }}
        >
          {/* Key by case id (not array index) so React keeps each row bound
              to its case across sort/filter reorders and paginated appends,
              matching how the reducer updates cases by id. */}
          {cases.map((theCase, index) => {
            const selected = selections[sidebarStatus] === theCase.id;
            return (
              <div
                key={"div_" + theCase.id}
                className={
                  theCase.hidden
                    ? styles.case_row_folded
                    : styles.case_row_unfolded
                }
              >
                <CasesRow
                  key={theCase.id}
                  data={theCase}
                  index={index}
                  selected={selected}
                />
              </div>
            );
          })}
        </Scrollbar>
      </InfiniteScroll>
    </div>
  );
}

export default CaseList;
